import Swiper from 'swiper/bundle';

document.addEventListener('DOMContentLoaded', function () {
    const sliders = document.querySelectorAll(".two-columns__slider");

    sliders.forEach(function (slider) {
        const parentMedia = slider.closest(".two-columns__media");

        const videoSwiper = new Swiper(slider, {
            loop: true,
            navigation: {
                nextEl: parentMedia.querySelector(".swiper-button-next"),
                prevEl: parentMedia.querySelector(".swiper-button-prev"),
            }
        });
    });
});